module.exports = "<button class=\"sidebar-minimizer\" type=\"button\" appSidebarMinimizer appBrandMinimizer></button>\n"


//////////////////
// WEBPACK FOOTER
// /home/dfm/cryosoft/ui/src/app/components/app-sidebar-minimizer/app-sidebar-minimizer.component.html
// module id = ../../../../../src/app/components/app-sidebar-minimizer/app-sidebar-minimizer.component.html
// module chunks = main